import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  StorageFile,
  StorageUtilsService,
} from '../../services/storage-utils.service';
import { ListItem } from 'src/app/components/scrolling-list';

@Component({
  selector: 'rename-file-modal',
  templateUrl: './rename-file-modal.component.html',
  styleUrls: ['./rename-file-modal.component.scss'],
  standalone: false,
})
export class RenameFileModalComponent implements OnInit {
  selectedFile!: ListItem<StorageFile>;

  isFolder: boolean;
  renameName: string = '';
  parentPath: string = '';
  extension: string = '';
  isProcessing: boolean = false;
  errorMessage: string = '';

  get validDestination() {
    return this.renameName && this.renameName.indexOf('/') === -1;
  }

  constructor(
    public dialogRef: MatDialogRef<RenameFileModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { selectedFile: ListItem<StorageFile> },
    private storageUtilsService: StorageUtilsService,
    private ngZone: NgZone,
  ) {
    this.selectedFile = data.selectedFile;
  }

  ngOnInit(): void {
    this.isFolder = this.storageUtilsService
      .fileName(this.selectedFile.item)
      .endsWith('/');
    this.renameName = this.storageUtilsService
      .fileName(this.selectedFile.item)
      .replace('/', '');
    this.parentPath = this.storageUtilsService.fileParent(
      this.selectedFile.item,
    );
    if (!this.isFolder) {
      const extensionIndex = this.renameName.lastIndexOf('.');
      if (extensionIndex >= 0) {
        this.extension = this.renameName.substring(extensionIndex);
        this.renameName = this.renameName.substring(0, extensionIndex);
      }
    }
  }

  update() {
    this.ngZone.run(() => {});
  }

  ok() {
    this.errorMessage = '';
    this.isProcessing = true;

    let renameTo = this.renameName;
    if (this.extension) {
      renameTo += this.extension;
    }

    this.dialogRef.close(this.parentPath + renameTo);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
